import React, { useEffect, useState } from "react";
import { getCircular } from "../Service/Api";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Footer from "../Component/Footer";

const GlimpseOfTheDay = () => {
  useEffect(() => {
    document.title = "Glimpse Of The Day-  St Peters convent School Faridabad Haryana";
  }, []);

  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [searchQuery, setSearchQuery] = useState("");

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getCircular();
        const glimpseData = (galleryData || []).filter((item) => {
          const category = (item?.category || "").replace(/'+/g, "").trim();
          return category === "Glimpse";
        });

        setData(glimpseData);

        const uniqueYears = Array.from(
          new Set(glimpseData.map((item) => (item.date ? new Date(item.date).getFullYear() : null)).filter(Boolean))
        );
        uniqueYears.sort((a, b) => a - b);
        setYearRanges(["All", ...uniqueYears.map((year) => `${year}`)]);

        const uniqueMonths = Array.from(
          new Set(glimpseData.map((item) => (item.date ? new Date(item.date).getMonth() : null)).filter((m) => m !== null))
        );
        const sortedMonths = uniqueMonths.sort((a, b) => a - b).map((month) => monthNames[month]);
        setMonthOptions(["All", ...sortedMonths]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filtered = [...data];

    if (selectedYear !== "All") {
      filtered = filtered.filter((item) => {
        if (item.date) {
          const year = new Date(item.date).getFullYear();
          return parseInt(selectedYear, 10) === year;
        }
        return false;
      });
    }

    if (selectedMonth !== "All") {
      filtered = filtered.filter((item) => {
        if (item.date) {
          const month = new Date(item.date).getMonth();
          return monthNames[month] === selectedMonth;
        }
        return false;
      });
    }

    if (searchQuery) {
      filtered = filtered.filter((item) => (item?.title || "").toLowerCase().includes(searchQuery.toLowerCase()));
    }

    const currentMonthData = filtered.filter((item) => {
      if (item.date) {
        const itemDate = new Date(item.date);
        return itemDate.getFullYear() === currentYear && itemDate.getMonth() === currentMonth;
      }
      return false;
    });

    const otherData = filtered.filter((item) => !currentMonthData.includes(item));
    otherData.sort((a, b) => new Date(b.date) - new Date(a.date));

    setFilteredData([...currentMonthData, ...otherData]);
  }, [data, selectedYear, selectedMonth, searchQuery]);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li>Events </li>
          {/* <li>Glimpse Of The Day </li> */}
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* <h1>Glimpse Of The Day</h1> */}
              <h1>Events</h1>
            </div>
          </div>

          <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                <p>Total Count: {filterData.length} </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} className="yearSelection">
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} className="monthSelect">
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>

          <div className="row years year2023 showYear">
            {filterData.length > 0 &&
              filterData.map((item, index) => {
                const firstImage = Array.isArray(item?.images) && item.images.length > 0 ? item.images[0] : null;
                const firstAttachment = Array.isArray(item?.attachments) && item.attachments.length > 0 ? item.attachments[0] : null;
                const previewSrc = firstImage
                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${firstImage}`
                  : firstAttachment
                  ? "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg"
                  : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg";
                const previewHref = firstImage
                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${firstImage}`
                  : firstAttachment
                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${firstAttachment}`
                  : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg";

                return (
                  <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 eventCount" key={index}>
                    <div className="eventbox">
                      <div className="eventboximg">
                        {firstAttachment && (
                          <div className="eventattch">
                            <Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${firstAttachment}`} target="_blank">
                              <i className="bi bi-paperclip"></i>
                            </Link>
                          </div>
                        )}
                        <LazyLoad>
                          <a data-magnify="gallery" data-src={previewSrc} data-group="a" href={previewHref}>
                            <img src={previewSrc} alt="Glimpse" className="img-fluid" />
                          </a>
                        </LazyLoad>
                      </div>
                      <div className="eventboxdesc">
                        <div className="eventpgh">
                          <h5>{item?.title}</h5>
                          {item?.description ? <p>{item.description}</p> : null}
                          {item?.url ? (
                            <p>
                              <a href={item.url} target="_blank" rel="noopener noreferrer">
                                Click here
                              </a>
                            </p>
                          ) : null}
                        </div>
                        
                        <div className="eventdate">
                          <span>
                            <i className="bi bi-calendar"></i> {item?.date || "-"}
                          </span>
                          {item?.time ? (
                            <span>
                              <i className="bi bi-alarm"></i>
                              {item.time}
                            </span>
                          ) : null}
                          {item?.venue ? (
                            <span>
                              <i className="bi bi-geo-alt"></i> {item.venue}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GlimpseOfTheDay;
